import React, { useEffect, useState } from "react";
import { FxIconValuePanel } from "./components/FxIconValuePanel";
import { AttrList } from "../fxms/datas/OpClass";
import { FxDataSearch } from "../fxms/inputs/FxDataSearch";
import { FxmsData } from "../fxms/datas/FxData";
import { FxWindow } from "../fxms/windows/FxWindows";
import { toKSTISOString } from "./common/commonMethod";

export const VupDash = (props) => {
  const [filter, setFilter] = useState([]);
  const [inloList, setInloList] = useState([]);
  const [values, setValues] = useState({});
  const inloClCd = 'COMPLEX';
  let engList =    FxmsData.getDatas("energy");


  /**
   * 생산량 데이터 가져오기
   * @param {*} inputData 
   */
  async function showDatas(inputData) {

    const tmpValue = {};
    engList = FxmsData.getDatas("energy");

    for (let e of engList) {
      tmpValue[e.engId] = {};
    }

    if (inputData === undefined) {
      let today = new Date();
      const todayStr = toKSTISOString(today);
      let date = todayStr.replaceAll("-", ".");
      inputData = { prodDateStart: date, prodDateEnd: date };
    }

    const para = inputData ? { ...inputData } : {};
    para.inloClCd = inloClCd;

    const list = await FxmsData.GET("vup/dash/toc", para);

    for (const data of list.data) {
      if (tmpValue[data.engId] && data.inloNo) {
        if (tmpValue[data.engId][data.inloNo]) {
          tmpValue[data.engId][data.inloNo].now = data.prodAmt;
          tmpValue[data.engId][data.inloNo].sum += data.prodAmt;
          tmpValue[data.engId][data.inloNo].list.push(data);
        } else {
          tmpValue[data.engId][data.inloNo] = {};
          tmpValue[data.engId][data.inloNo].list = [];
          tmpValue[data.engId][data.inloNo].now = data.prodAmt;
          tmpValue[data.engId][data.inloNo].sum = data.prodAmt;
          tmpValue[data.engId][data.inloNo].list.push(data);
        }
      }
    }

    console.log('*** VupDash *** energy', engList);
    console.log('*** VupDash *** select-datas', list);
    console.log('*** VupDash *** show-datas', tmpValue);

    setValues(tmpValue);
  }

  function clickButton(inputData) {
    showDatas(inputData);
  }

  useEffect(() => {

    
    const filterList = new AttrList("filter");

    filterList.addDate("prodDateStart", "조회기간", "right").attrDftVal = "day,-7";
    filterList.addDate("prodDateEnd", "~", "right");
    filterList.addButton("검색", clickButton, "right");

    // return에 넣으면 계속 렌더링하여 입력된 값이 없어짐.
    setFilter(
      <FxDataSearch
        attrList={filterList.getList()}
        // onShowData={onShowData}
        // onInputData={onInputData}
        inputType="Search"
      />
    );

    // 위치 정보 가져오기
    const tmpInloList = FxmsData.getDatas("inlo", { inloClCd: inloClCd });
    if (tmpInloList) {
      setInloList(tmpInloList);
    }

    FxWindow.showNavigator("VUP 대시보드");

  }, []);


  useEffect(() => {

    showDatas();

  }, [inloList]);

  return (
    <div>
      <div className="FxCrudFilter">{filter}</div>
      <div className="VupDash"> {
        engList ? engList.map((eng, index) => {
          return (
            <FxIconValuePanel key={eng.engId} energy={eng} inloList={inloList} allValues={values} />
          )
        }) : ""}</div>
    </div>
  );

}